import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal } from '../Modal/Modal'
import Portal from 'components/Portal/Portal'
import MaskEditor from './MaskEditor'
import { Attribute } from './Attribute'
import { BUSINESS_RULES } from '../Wizard2/businessRules'

class ValidationButton extends Component {
  constructor() {
    super()
    this.state = { modalOpen: false }
    this.editorRef = React.createRef()
  }
  toggleEditor = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }
  saveRules = () => {
    if (this.props.maskEditor) {
      this.editorRef.current.saveRules()
    } else {
      this.editorRef.current.saveRules()
    }
  }
  cancel = () => {
    if (this.props.maskEditor) {
      this.editorRef.current.clearState()
    }
  }
  render() {
    const {
      numRules,
      handleChange,
      field,
      label = 'Edit Business Rules',
      maskEditor,
      allRules,
      allowedRules,
      ruleKey,
      buttonClassName,
    } = this.props
    return (
      <div className="block-wrapper">
        <button
          className={`attribute-button validation-button ${buttonClassName}`}
          onClick={this.toggleEditor}
        >
          {numRules > 0 ? <span className="rules-flag">{numRules}</span> : null}
          <span className="button-text">{label}</span>
        </button>
        <Portal isOpened={this.state.modalOpen}>
          <Modal
            title={label}
            closeModal={this.toggleEditor}
            modalSize="large"
            saveAndCloseButton={true}
            cancelButton={true}
            save={this.saveRules}
            cancel={this.cancel}
          >
            {maskEditor ? (
              <MaskEditor ref={this.editorRef} field={field} handleChange={handleChange} />
            ) : (
              <ValidationEditor
                ref={this.editorRef}
                field={field}
                handleChange={handleChange}
                allowedRules={allowedRules}
                allRules={allRules}
                ruleKey={ruleKey}
              />
            )}
          </Modal>
        </Portal>
      </div>
    )
  }
}
export default connect((state) => ({}))(ValidationButton)

class ValidationEditor extends Component {
  constructor({ field, ruleKey, allowedRules }) {
    super()
    this.state = {
      businessRules: ruleKey ? field[ruleKey] : field.businessRules,
      allowedRules: allowedRules || field.allowedRules,
      selectedRule: null,
    }
  }
  isInArray(key) {
    let found = false
    this.state.businessRules.map((currentRule) => {
      if (key === currentRule.ruleId || key === currentRule.fn) {
        found = true
      }
      return null
    })
    return found
  }
  addRule = (oldRule, fn, ruleId) => {
    let props = {}
    Object.keys(oldRule.props).map((key, i) => {
      props[key] = oldRule.props[key].value
      return null
    })
    let rule = { fn, ruleId, props }
    let rules = [...this.state.businessRules, rule]
    this.setState({ businessRules: rules, selectedRule: ruleId })
  }
  removeRule = (ruleId) => {
    let rules = [...this.state.businessRules]
    let newRules = []
    rules.map((rule, i) => {
      if (rule.ruleId !== ruleId) {
        newRules.push(rule)
      }
      return null
    })
    this.setState({ businessRules: newRules, selectedRule: null })
  }
  loadProps = (ruleId) => {
    if (this.isInArray(ruleId)) {
      this.setState({ selectedRule: ruleId })
    }
  }
  setPropValue = (name, value) => {
    let rules = [...this.state.businessRules]
    let ruleId = this.state.selectedRule
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].ruleId === ruleId) {
        let props = { ...rules[i].props }
        props[name] = value
        rules[i] = { ...rules[i], props }
      }
    }
    this.setState({ businessRules: rules })
  }
  saveRules = () => {
    this.props.handleChange('businessRules', this.state.businessRules)
  }
  render() {
    const { allRules, field } = this.props
    const ALL_RULES = allRules || BUSINESS_RULES
    return (
      <div className="validation-editor">
        <div className="row">
          <div className="col-6 rule-container">
            {this.state.allowedRules ? (
              this.state.allowedRules.map((key, i) => {
                let rule = ALL_RULES[key]
                return (
                  <BusinessRule
                    selected={key === this.state.selectedRule}
                    checked={this.isInArray(key)}
                    addRule={this.addRule}
                    removeRule={this.removeRule}
                    loadProps={this.loadProps}
                    isSubField={this.state.isSubField}
                    ruleId={key}
                    name={rule.name}
                    rule={rule}
                    fn={rule.fn}
                    key={i}
                    disabled={key === 'doubleValidateOnAdvance' && !field.requireDoubleValidation}
                  />
                )
              })
            ) : (
              <div>No allowed business rules</div>
            )}
          </div>
          <div className="attribute-container col-6">
            {this.state.selectedRule
              ? Object.keys(ALL_RULES[this.state.selectedRule].props).map((key, i) => {
                  let template = ALL_RULES[this.state.selectedRule].props[key]
                  let prop = this.state.businessRules.find(
                    (rule) => rule.ruleId === this.state.selectedRule
                  ).props[key]
                  return (
                    <Attribute
                      {...template}
                      parentField={this.props.field}
                      name={key}
                      value={prop}
                      handleChange={this.setPropValue}
                      key={i}
                    />
                  )
                })
              : null}
          </div>
        </div>
      </div>
    )
  }
}
ValidationEditor = connect(null, null, null, { forwardRef: true })(ValidationEditor)

const BusinessRule = (props) => {
  const { checked, selected, loadProps, rule, ruleId, name, addRule, removeRule, fn, disabled } =
    props

  const toggleRule = (e) => {
    if (e.target.checked) {
      addRule(rule, fn, ruleId)
    } else {
      removeRule(ruleId)
    }
  }

  return (
    <div
      className={'rule ' + (checked ? 'checked ' : '') + (selected ? 'selected ' : '')}
      onClick={() => {
        loadProps(ruleId)
      }}
    >
      <input
        type="checkbox"
        disabled={rule.deprecated ? (checked ? false : true) : disabled ? true : false}
        checked={checked}
        onChange={
          rule.deprecated ? (checked ? toggleRule : undefined) : disabled ? undefined : toggleRule
        }
      />
      <span className="rule-name">
        <span>{name}</span>{' '}
        {rule.deprecated ? <span className="deprecated">[deprecated]</span> : null}
      </span>
    </div>
  )
}
